export function getVerboseElapsed(ts) {
	var now = Math.floor(new Date().getTime() / 1000);

	var seconds = now - ts;

	if (45 > seconds) return "Just now";
	if (seconds >= 45 && seconds < 120) return "A minute ago";

	var minutes = Math.floor(seconds / 60);
	if (minutes < 60) return `${minutes} minutes ago`;

	var hours = Math.floor(seconds / 3600);
	if (hours === 1) return "An hour ago";
	if (hours < 24) return `${hours} hours ago`;

	var days = Math.floor(hours / 24);
	if (days === 1) return "Yesterday";
	if (days < 7) return `${days} days ago`;

	var weeks = Math.floor(days / 7);
	if (weeks === 1) return "Last week";
	if (weeks < 4) return `${weeks} weeks ago`;
	if (weeks >= 4 && weeks < 8) return "Last month"

	var months = Math.floor(weeks / 4);
	if (months < 12) return `${months} months ago`;

	var years = Math.floor(days / 365);
	if (years < 2) return "Last year";
	return `${years} years ago`;
}